import React from 'react';
import { AdminContextProvider } from './context/AdminContext';
import { AdminDashboardContainer } from './components';

function AdminDashboard() {
  return (
    <AdminContextProvider>
      <AdminDashboardContainer />
    </AdminContextProvider>
  );
}

export default AdminDashboard;